import { useAtomValue } from "jotai";
import { userData } from "./store";
import { Navigate, Outlet } from "react-router-dom";
import { useEffect } from "react";

const ProtectedRoute = () => {
  const user = useAtomValue(userData);

  useEffect(() => {
    if (!user?.token) {
      localStorage.removeItem("JHU-Etranscript");
      window.location.href = "/"
    }
  }, [user?.token])

  if (user?.token) {
    return <Outlet />;
  }

  return <Navigate to="/profile" replace />;
};

export default ProtectedRoute;
